'use client'
import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { sendGAEvent } from '@next/third-parties/google'

const BlogCard = ({ blog, dictionary }) => {
  return (
    <div
        className='w-full my-2 rounded-md text-maincolor flex sm:flex-row flex-col-reverse justify-between border-[1px] border-forth hover:shadow-md'
    >
        <div className='flex flex-col sm:p-4 p-2 sm:w-2/3 w-full justify-between'>
            <span className='font-semibold text-third text-sm'>{blog.createdAt?.split('T')?.[0]}</span>
            <span className='font-semibold text-maincolor mb-4'>{blog.title}</span>
            <p className='text-secondary overflow-clip'>{blog.excerpt}</p>
            <Link 
                onClick={() => sendGAEvent({ 
                    event: "select_content",
                    blog_id: blog._id.toString(),
                    blog_name: blog.title,
                })} 
                className='cursor-pointer sm:w-[200px] w-full flex justify-center items-center rounded-lg px-2 mt-2 py-1 shadow-md focus:outline-none bg-maincolor text-light' 
                href={`/blogs/${blog.slug}`} blog={blog}><span>{dictionary.blog.read}</span></Link>
        </div>
        <div className='relative sm:w-1/3 w-full aspect-[4/3] rounded-r-md sm:rounded-l-none rounded-l-md overflow-hidden'>
            <Image
                // placeholder="blur"
                // blurDataURL={property.blur}
                // className='object-fit'
                className='object-cover'
                src={blog?.cloudThumbnail ? blog.cloudThumbnail : '/images/test.jpg'}
                // width={imageWidth}
                // height={imageHeight}
                fill={true}
                // alt={property.slug}
            />
        </div>
    </div>
  )
}

export default BlogCard